(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mag-community-moments"] && !Shopify.designMode) return;
  try {
    
(() => {
  // 按图片设定比例计算两列高度，再由较短一列的最后一张图片补齐底部。
  function setup(root) {
    if (!root || root.dataset.cmReady === 'true') return;
    const grid = root.querySelector('.magcommunity__grid');
    if (!grid) return;
    root.dataset.cmReady = 'true';
    let frame = 0, lastWidth = -1;
    const mobile = window.matchMedia('(max-width: 749px)');
    const cards = () => Array.from(grid.children).filter(node => node.classList.contains('magcommunity__card'));
    function ratio(card) {
      const value = card.dataset.mobileRatio || '4 / 5';
      const match = value.match(/^(\d+(?:\.\d+)?)\s*\/\s*(\d+(?:\.\d+)?)$/);
      if (match && Number(match[1]) > 0 && Number(match[2]) > 0) return Number(match[1]) / Number(match[2]);
      const image = card.querySelector('.magcommunity__image');
      if (!image) return 1;
      const width = image.naturalWidth || Number(image.getAttribute('width'));
      const height = image.naturalHeight || Number(image.getAttribute('height'));
      return width > 0 && height > 0 ? width / height : 1;
    }
    function layout() {
      frame = 0;
      const items = cards();
      if (!mobile.matches) {
        grid.classList.remove('is-masonry-aligned');
        items.forEach(card => { card.style.gridRowEnd = ''; });
        return;
      }
      const width = grid.clientWidth;
      if (!width) return;
      const computed = getComputedStyle(root);
      const gap = Math.max(0, parseFloat(computed.getPropertyValue('--cm-gap-m')) || 0);
      const cardWidth = (width - gap) / 2;
      if (!(cardWidth > 0)) return;
      const heights = [0, 0], last = [-1, -1], spans = [];
      items.forEach((card, index) => {
        const column = heights[0] <= heights[1] ? 0 : 1;
        let contentHeight = Math.ceil(cardWidth / ratio(card));
        if (card.querySelector('.magcommunity__placeholder')) contentHeight = Math.max(120, contentHeight);
        const span = Math.max(1, contentHeight + Math.ceil(gap));
        spans[index] = span;
        heights[column] += span;
        last[column] = index;
      });
      if (last[0] >= 0 && last[1] >= 0) {
        const shorter = heights[0] <= heights[1] ? 0 : 1;
        spans[last[shorter]] += Math.abs(heights[0] - heights[1]);
      }
      items.forEach((card, index) => { card.style.gridRowEnd = 'span ' + spans[index]; });
      grid.classList.add('is-masonry-aligned');
    }
    function schedule() { if (!frame) frame = requestAnimationFrame(layout); }
    const observer = window.ResizeObserver ? new ResizeObserver(entries => {
      const width = entries[0].contentRect.width;
      if (Math.abs(width - lastWidth) > .25) { lastWidth = width; schedule(); }
    }) : null;
    if (observer) observer.observe(grid);
    const mutations = window.MutationObserver ? new MutationObserver(schedule) : null;
    if (mutations) mutations.observe(grid, {childList: true});
    root.addEventListener('load', schedule, true);
    window.addEventListener('resize', schedule);
    root._magCommunityCleanup = () => {
      if (frame) cancelAnimationFrame(frame);
      if (observer) observer.disconnect();
      if (mutations) mutations.disconnect();
      root.removeEventListener('load', schedule, true);
      window.removeEventListener('resize', schedule);
      delete root.dataset.cmReady;
    };
    schedule();
  }
  function init(scope) {
    if (scope.matches && scope.matches('.magcommunity')) setup(scope);
    if (scope.querySelectorAll) scope.querySelectorAll('.magcommunity').forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    const root = event.target.querySelector('.magcommunity');
    if (root && root._magCommunityCleanup) root._magCommunityCleanup();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mag-dynamic-collection"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('mag-dynamic-collection')) return;
  class MagDynamicCollection extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.cache = new Map();
      this.requestToken = 0;
      this.drawer = this.querySelector('.mec__drawer');
      this.quickDialog = this.querySelector('.mec__quick-dialog');
      this.quickBody = this.querySelector('[data-quick-body]');
      const signal = this.controller.signal;
      this.addEventListener('click', event => this.onClick(event), {signal});
      this.addEventListener('change', event => {
        if (event.target.matches('[data-sort-select]')) event.target.form.requestSubmit();
      }, {signal});
      this.addEventListener('submit', event => {
        if (event.target.matches('[data-filter-form]')) this.applyFilters(event);
        if (event.target.matches('[data-sort-form]')) {
          event.preventDefault();
          const form = event.target, url = new URL(form.action, location.origin);
          url.search = '';
          new FormData(form).forEach((value,key) => { if (String(value).trim() !== '') url.searchParams.append(key,value); });
          this.loadCollection(url.href);
        }
      }, {signal});
      this.addEventListener('input', event => {
        if (event.target.matches('[data-price-min],[data-price-max]')) {
          this.querySelectorAll('[data-price-min],[data-price-max]').forEach(input => input.setCustomValidity(''));
        }
      }, {signal});
      const track = this.querySelector('[data-nav-track]');
      const previous = this.querySelector('[data-nav-prev]'), next = this.querySelector('[data-nav-next]');
      const updateArrows = () => {
        if (!track || !previous || !next) return;
        track.classList.remove('is-fit');
        const fits = track.scrollWidth <= track.clientWidth + 1;
        track.classList.toggle('is-fit', fits);
        previous.disabled = fits || track.scrollLeft <= 2;
        next.disabled = fits || track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      track?.addEventListener('scroll', updateArrows, {signal,passive:true});
      window.addEventListener('resize', updateArrows, {signal});
      requestAnimationFrame(updateArrows);
      this.querySelectorAll('dialog').forEach(dialog => {
        dialog.addEventListener('close', () => {
          if (this.openModal === dialog) {
            document.documentElement.style.overflow = this.previousOverflow || '';
            this.openModal = null;
            this.requestToken++;
            if (this.returnFocus?.isConnected) this.returnFocus.focus({preventScroll:true});
          }
        }, {signal});
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const r = dialog.getBoundingClientRect();
          if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
        }, {signal});
      });
    }
    disconnectedCallback() {
      if (this.openModal?.open) this.openModal.close();
      this.controller?.abort();
      this.swapController?.abort();
      this.controller = null;
      this.requestToken++;
    }
    onClick(event) {
      const track = this.querySelector('[data-nav-track]');
      if (event.target.closest('[data-nav-prev]') && track) { track.scrollBy({left:-track.clientWidth * .8,behavior:'smooth'}); return; }
      if (event.target.closest('[data-nav-next]') && track) { track.scrollBy({left:track.clientWidth * .8,behavior:'smooth'}); return; }
      const link = event.target.closest('[data-collection-tab], .mec__pagination a, .mec__active a, .mec__empty a, .mec__filter-footer a');
      if (link && this.contains(link) && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0) {
        event.preventDefault(); this.loadCollection(link.href, {scrollToProducts: link.matches('[data-collection-tab]')}); return;
      }
      const open = event.target.closest('[data-open-filters]');
      if (open && this.contains(open)) { this.openDialog(this.drawer, open); return; }
      const close = event.target.closest('[data-close-dialog]');
      if (close && this.contains(close)) { close.closest('dialog').close(); return; }
      const quick = event.target.closest('[data-quick-view]');
      if (quick && this.contains(quick)) { this.showQuickView(quick.closest('[data-product-card]'), quick); return; }
      const swatch = event.target.closest('button[data-color-value]');
      if (swatch && this.contains(swatch)) this.selectCardColor(swatch);
    }
    openDialog(dialog, trigger) {
      if (!dialog) return;
      if (this.openModal?.open) this.openModal.close();
      this.returnFocus = trigger;
      this.previousOverflow = document.documentElement.style.overflow;
      this.openModal = dialog;
      dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      dialog.querySelector('[data-close-dialog]')?.focus({preventScroll:true});
    }
    applyFilters(event) {
      event.preventDefault();
      const form = event.target;
      const min = form.querySelector('[data-price-min]');
      const max = form.querySelector('[data-price-max]');
      if (min && max && min.value !== '' && max.value !== '' && Number(min.value) > Number(max.value)) {
        max.setCustomValidity('Maximum price must be greater than or equal to minimum price.');
        max.reportValidity(); return;
      }
      if (!form.reportValidity()) return;
      const url = new URL(form.action, location.origin);
      url.search = '';
      new FormData(form).forEach((value, key) => {
        if (String(value).trim() !== '') url.searchParams.append(key, value);
      });
      this.loadCollection(url.href);
    }
    async loadCollection(address, options = {}) {
      let url;
      try { url = new URL(address, location.href); } catch (_) { return; }
      if (url.origin !== location.origin) return;
      url.searchParams.delete('section_id'); url.searchParams.delete('sections');
      const requested = new URL(url.href);
      // 使用 section 文件名作为静态 section ID，允许在其他模板的商品系列上下文中渲染。
      // 原页面的导航、图文场景、布局样式和编辑器设置保留在当前 section 中。
      const renderer = 'mag-dynamic-collection';
      requested.searchParams.set('section_id', renderer);
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview && !requested.searchParams.has('preview_theme_id')) requested.searchParams.set('preview_theme_id',preview);
      const status = this.querySelector('[data-load-status]');
      if (this.swapController) this.swapController.abort();
      const controller = this.swapController = new AbortController();
      if (status) status.textContent = 'Loading…';
      this.setAttribute('aria-busy','true');
      try {
        // 首先使用 Shopify 单分区 HTML 接口，避免集合对象 JSON 被当作分区响应。
        const response = await fetch(requested.href, {signal:controller.signal,credentials:'same-origin',headers:{Accept:'text/html'}});
        let html = response.ok ? await response.text() : '';
        let doc = new DOMParser().parseFromString(html,'text/html');
        let fetched = doc.getElementById('MEC-' + renderer);
        // 若该主题没有返回单分区 HTML，再尝试多分区 JSON 格式，不强制请求集合 JSON。
        if (!fetched) {
          const fallback = new URL(requested.href);
          fallback.searchParams.delete('section_id');
          fallback.searchParams.set('sections',renderer);
          const alternate = await fetch(fallback.href,{signal:controller.signal,credentials:'same-origin'});
          if (!alternate.ok) throw new Error('Section unavailable');
          const data = await alternate.json();
          html = data && data[renderer];
          if (typeof html !== 'string' || !html.trim()) throw new Error('Section unavailable');
          doc = new DOMParser().parseFromString(html,'text/html');
          fetched = doc.getElementById('MEC-' + renderer);
        }
        const sourceInner = fetched?.querySelector('.mec__inner');
        const destInner = this.querySelector('.mec__inner');
        const newGrid = sourceInner?.querySelector(':scope > .mec__grid');
        const newDrawer = fetched?.querySelector('.mec__drawer');
        if (!sourceInner || !destInner || !newGrid || !newDrawer || !this.drawer) throw new Error('Section unavailable');
        if (this.swapController !== controller || !this.isConnected) return;
        // 重建 ID 引用，让新卡片/筛选面板关联当前模块中的弹窗。
        const oldId = 'MEC-' + renderer;
        const liveId = this.id;
        const oldSuffix = '-' + renderer;
        const liveSuffix = '-' + this.dataset.sectionId;
        fetched.querySelectorAll('*').forEach(node => {
          ['id','for','aria-controls','aria-labelledby','aria-describedby'].forEach(attr => {
            const value = node.getAttribute(attr);
            if (value && (value.startsWith('MEC-') || value.includes(oldId))) {
              node.setAttribute(attr,value.split(oldSuffix).join(liveSuffix));
            }
          });
        });
        // 场景图及其内容从当前模板保留，不使用静态渲染的默认区块。
        const scenes = [...destInner.querySelectorAll(':scope > .mec__grid > .mec__scene')];
        const products = [...newGrid.querySelectorAll(':scope > .mec__product')];
        scenes.forEach(scene => {
          const n = Math.max(0, Number.parseInt(scene.dataset.sceneAfter || '0',10) || 0);
          const reference = products[Math.min(n,products.length)] || null;
          newGrid.insertBefore(scene,reference);
        });
        if (this.openModal?.open) this.openModal.close();
        const selectors = '.mec__toolbar, .mec__active, .mec__grid, .mec__empty, .mec__pagination';
        [...destInner.children].filter(node => node.matches(selectors)).forEach(node=>node.remove());
        [...sourceInner.children].filter(node => node.matches(selectors)).forEach(node=>destInner.append(node));
        // 保留原 dialog 元素以保留已绑定的关闭与键盘行为，只更新筛选内容。
        this.drawer.replaceChildren(...newDrawer.childNodes);
        const activeUrl = new URL(url.href);
        this.querySelectorAll('[data-collection-tab]').forEach(link => {
          const linkUrl = new URL(link.href,location.href);
          const norm = path => path.replace(/\/+$/,'');
          if (norm(linkUrl.pathname) === norm(activeUrl.pathname)) link.setAttribute('aria-current','true');
          else link.removeAttribute('aria-current');
        });
        this.dataset.collectionUrl = activeUrl.pathname;
        if (status) status.textContent = '';
        if (options.scrollToProducts) {
          requestAnimationFrame(() => {
            if (this.isConnected && this.swapController === controller) this.scrollToProducts();
          });
        }
      } catch (error) {
        if (error.name === 'AbortError') return;
        if (status) status.textContent = 'Could not load this collection. Please try again.';
      } finally {
        if (this.isConnected && this.swapController === controller) this.removeAttribute('aria-busy');
      }
    }
    scrollToProducts() {
      const target = this.querySelector('.mec__toolbar') || this.querySelector('.mec__grid');
      if (!target) return;
      // 避开当前悬浮在顶部的导航栏，并兼容主题提供的 header 高度变量。
      const viewportLimit = Math.min(200, window.innerHeight * .4);
      const themeHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
      let headerHeight = Math.min(Math.max(themeHeight, 0), viewportLimit);
      document.querySelectorAll('header, [data-sticky-header], .shopify-section-group-header-group').forEach(node => {
        const position = getComputedStyle(node).position;
        if (position !== 'fixed' && position !== 'sticky') return;
        const rect = node.getBoundingClientRect();
        if (rect.top <= 12 && rect.bottom > 0 && rect.height <= viewportLimit) headerHeight = Math.max(headerHeight, rect.bottom);
      });
      const top = Math.max(0, window.scrollY + target.getBoundingClientRect().top - Math.min(headerHeight,viewportLimit) - 12);
      const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({top, behavior: reduce ? 'auto' : 'smooth'});
    }
    routeRoot() {
      let root = window.Shopify?.routes?.root || this.dataset.root || '/';
      return root.endsWith('/') ? root : root + '/';
    }
    async product(url) {
      const u = new URL(url, location.origin);
      const handle = u.pathname.split('/').filter(Boolean).pop();
      const endpoint = this.routeRoot() + 'products/' + encodeURIComponent(decodeURIComponent(handle)) + '.js';
      if (!this.cache.has(endpoint)) {
        const promise = fetch(endpoint, {credentials:'same-origin', headers:{Accept:'application/json'}})
          .then(response => { if (!response.ok) throw new Error('Product could not be loaded.'); return response.json(); })
          .then(data => { if (!Array.isArray(data.variants)) throw new Error('Product could not be loaded.'); return data; })
          .catch(error => { this.cache.delete(endpoint); throw error; });
        this.cache.set(endpoint, promise);
      }
      return this.cache.get(endpoint);
    }
    money(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:this.dataset.currency || 'USD'}).format(Number(cents || 0) / 100);
    }
    node(tag, className, text) {
      const element = document.createElement(tag);
      if (className) element.className = className;
      if (text !== undefined) element.textContent = text;
      return element;
    }
    imageUrl(value, width = 960) {
      const raw = typeof value === 'object' ? value?.src || value?.url : value;
      if (!raw) return '';
      const url = new URL(raw, location.origin);
      if (!['https:','http:'].includes(url.protocol)) return '';
      url.searchParams.set('width', String(width));
      return url.href;
    }
    setImage(image, value) {
      const url = this.imageUrl(value);
      if (!url || !image) return;
      image.srcset = [240,360,480,640,960].map(width => this.imageUrl(value,width) + ' ' + width + 'w').join(', ');
      image.src = url;
    }
    variantUrl(base, id) {
      const url = new URL(base, location.origin);
      if (id) url.searchParams.set('variant',String(id));
      return url.pathname + url.search;
    }
    async selectCardColor(button) {
      const card = button.closest('[data-product-card]');
      const status = card.querySelector('[data-card-status]');
      const index = Number(card.dataset.colorIndex);
      if (index < 0) return;
      const token = String(Number(card.dataset.requestToken || 0) + 1);
      card.dataset.requestToken = token;
      status.textContent = '';
      card.setAttribute('aria-busy','true');
      try {
        const p = await this.product(card.dataset.url);
        if (card.dataset.requestToken !== token || !this.isConnected) return;
        if (p.variants.length >= 250) { this.showQuickView(card,button); return; }
        const color = button.dataset.colorValue;
        const matches = p.variants.filter(v => v.options[index] === color);
        const variant = matches.find(v => v.available) || matches[0];
        if (!variant) { status.textContent = 'View the product page to choose this color.'; return; }
        card.dataset.color = color;
        card.dataset.variantId = String(variant.id);
        card.querySelectorAll('button[data-color-value]').forEach(b => b.setAttribute('aria-pressed',String(b === button)));
        card.querySelectorAll('[data-product-link]').forEach(a => a.href = this.variantUrl(card.dataset.url, variant.id));
        const mainSource = variant.featured_image?.src || variant.featured_image?.url || p.featured_image;
        this.setImage(card.querySelector('.mec__image--first'), mainSource);
        const currentPath = mainSource ? new URL(mainSource,location.origin).pathname : '';
        const imageIndex = p.images.findIndex(image => new URL(typeof image === 'string' ? image : image.src,location.origin).pathname === currentPath);
        if (p.images.length > 1) {
          const next = p.images[(Math.max(0,imageIndex) + 1) % p.images.length];
          this.setImage(card.querySelector('.mec__image--next'), next);
        }
        const amounts = matches.map(v => Number(v.price));
        const low = Math.min(...amounts), high = Math.max(...amounts);
        const price = card.querySelector('[data-card-price]');
        price.replaceChildren(this.node('span','', (low !== high ? 'From ' : '') + this.money(low)));
        if (low === high && variant.compare_at_price > low) price.append(this.node('s','',this.money(variant.compare_at_price)));
        const sizeIndex = Number(card.dataset.sizeIndex);
        card.querySelectorAll('[data-size-value]').forEach(size => {
          const available = matches.some(v => v.available && v.options[sizeIndex] === size.dataset.sizeValue);
          size.classList.toggle('mec__size-unavailable', !available);
        });
      } catch (error) {
        if (card.dataset.requestToken === token) status.textContent = 'Unable to update the preview. Open the product page for all options.';
      } finally {
        if (card.dataset.requestToken === token) card.removeAttribute('aria-busy');
      }
    }
    async showQuickView(card, trigger) {
      if (!card) return;
      this.quickBody.replaceChildren(this.node('p','mec__quick-status','Loading product…'));
      this.openDialog(this.quickDialog, trigger);
      const token = ++this.requestToken;
      try {
        const p = await this.product(card.dataset.url);
        if (token !== this.requestToken || !this.quickDialog.open || !this.isConnected) return;
        this.renderQuickView(p,card);
      } catch (error) {
        if (token !== this.requestToken || !this.quickDialog.open) return;
        const link = this.node('a','mec__details-link','View product details');
        link.href = card.dataset.url;
        this.quickBody.replaceChildren(this.node('p','','Unable to load Quick View. Please open the product page.'),link);
      }
    }
    renderQuickView(p,card) {
      const layout = this.node('div','mec__quick-layout');
      const image = this.node('img','mec__quick-image');
      image.alt = p.title; image.width = 800; image.height = 1000;
      if (p.featured_image) image.src = this.imageUrl(p.featured_image);
      else image.hidden = true;
      const info = this.node('div','mec__quick-info');
      const heading = this.node('h3','mec__quick-name',p.title);
      const price = this.node('p','mec__quick-price');
      const link = this.node('a','mec__details-link','View full details');
      link.href = card.dataset.url;
      info.append(heading,price);
      layout.append(image,info);
      this.quickBody.replaceChildren(layout);
      if (p.variants.length >= 250 || p.requires_selling_plan || p.variants.some(v=>v.requires_selling_plan)) {
        price.textContent = (p.price_varies ? 'From ' : '') + this.money(p.price);
        info.append(this.node('p','mec__quick-status','Choose your options on the product page.'),link);
        return;
      }
      const form = this.node('form','mec__quick-form');
      const options = (p.options || []).map((option,index) => ({
        name: typeof option === 'string' ? option : option.name,
        values: [...new Set(p.variants.map(v=>v.options[index]))].filter(v=>v != null)
      }));
      let selected = p.variants.find(v=>String(v.id) === card.dataset.variantId) || p.variants.find(v=>v.available) || p.variants[0];
      const singleDefault = options.length === 1 && options[0].name === 'Title' && options[0].values.length === 1 && options[0].values[0] === 'Default Title';
      const selects = [];
      if (!singleDefault) options.forEach((option,index) => {
        const label = this.node('label','mec__option',option.name);
        const select = this.node('select','mec__option-select');
        select.setAttribute('aria-label',option.name);
        option.values.forEach(value => {const item = this.node('option','',value); item.value = value; select.append(item);});
        select.value = selected?.options[index] || option.values[0] || '';
        label.append(select); form.append(label); selects.push(select);
      });
      const status = this.node('p','mec__quick-status'); status.setAttribute('role','status');
      const add = this.node('button','mec__primary','Add to cart'); add.type = 'submit';
      form.append(status,add); info.append(form,link);
      const update = (changedIndex = -1) => {
        selects.forEach((select,index) => {
          const prefix = selects.slice(0,index).map(s=>s.value);
          const purchasable = p.variants.filter(v => v.available && prefix.every((value,i)=>v.options[i]===value));
          [...select.options].forEach(option => {
            const available = purchasable.some(v=>v.options[index]===option.value);
            option.disabled = !available;
            option.textContent = option.value + (available ? '' : ' — Sold out');
          });
          if (index > changedIndex && changedIndex >= 0 && select.selectedOptions[0]?.disabled) {
            const first = [...select.options].find(option=>!option.disabled);
            if (first) select.value = first.value;
          }
        });
        const values = selects.map(s=>s.value);
        selected = singleDefault ? p.variants[0] : p.variants.find(v=>values.every((value,index)=>v.options[index]===value));
        price.replaceChildren(this.node('span','',this.money(selected?.price ?? p.price)));
        if (selected?.compare_at_price > selected?.price) price.append(this.node('s','',this.money(selected.compare_at_price)));
        add.disabled = !selected?.available;
        add.textContent = selected?.available ? 'Add to cart' : selected ? 'Sold out' : 'Unavailable';
        status.textContent = selected && !selected.available ? 'This option is currently sold out.' : '';
        link.href = this.variantUrl(card.dataset.url,selected?.id);
        const source = selected?.featured_image?.src || selected?.featured_image?.url || p.featured_image;
        if (source) {image.hidden = false; image.src = this.imageUrl(source);}
      };
      selects.forEach((select,index)=>select.addEventListener('change',()=>update(index)));
      update();
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (!selected?.available || add.disabled) return;
        add.disabled = true; add.textContent = 'Adding…'; status.textContent = '';
        try {
          const response = await fetch(this.routeRoot() + 'cart/add.js', {
            method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json',Accept:'application/json'},
            body:JSON.stringify({items:[{id:selected.id,quantity:1}]})
          });
          const data = await response.json();
          if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : 'Unable to add this item. Please try again.');
          location.assign(this.dataset.cartUrl || this.routeRoot() + 'cart');
        } catch (error) {
          status.textContent = error.message || 'Unable to add this item. Please try again.';
          add.disabled = !selected?.available; add.textContent = 'Add to cart';
        }
      });
    }
  }
  customElements.define('mag-dynamic-collection',MagDynamicCollection);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mag-editorial-collection"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('mag-editorial-collection')) return;
  class MagEditorialCollection extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.cache = new Map();
      this.requestToken = 0;
      this.drawer = this.querySelector('.mec__drawer');
      this.quickDialog = this.querySelector('.mec__quick-dialog');
      this.quickBody = this.querySelector('[data-quick-body]');
      const signal = this.controller.signal;
      this.addEventListener('click', event => this.onClick(event), {signal});
      this.addEventListener('change', event => {
        if (event.target.matches('[data-sort-select]')) event.target.form.requestSubmit();
      }, {signal});
      this.addEventListener('submit', event => {
        if (event.target.matches('[data-filter-form]')) this.applyFilters(event);
      }, {signal});
      this.addEventListener('input', event => {
        if (event.target.matches('[data-price-min],[data-price-max]')) {
          this.querySelectorAll('[data-price-min],[data-price-max]').forEach(input => input.setCustomValidity(''));
        }
      }, {signal});
      this.querySelectorAll('dialog').forEach(dialog => {
        dialog.addEventListener('close', () => {
          if (this.openModal === dialog) {
            document.documentElement.style.overflow = this.previousOverflow || '';
            this.openModal = null;
            this.requestToken++;
            if (this.returnFocus?.isConnected) this.returnFocus.focus({preventScroll:true});
          }
        }, {signal});
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const r = dialog.getBoundingClientRect();
          if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
        }, {signal});
      });
    }
    disconnectedCallback() {
      if (this.openModal?.open) this.openModal.close();
      this.controller?.abort();
      this.controller = null;
      this.requestToken++;
    }
    onClick(event) {
      const open = event.target.closest('[data-open-filters]');
      if (open && this.contains(open)) { this.openDialog(this.drawer, open); return; }
      const close = event.target.closest('[data-close-dialog]');
      if (close && this.contains(close)) { close.closest('dialog').close(); return; }
      const quick = event.target.closest('[data-quick-view]');
      if (quick && this.contains(quick)) { this.showQuickView(quick.closest('[data-product-card]'), quick); return; }
      const swatch = event.target.closest('button[data-color-value]');
      if (swatch && this.contains(swatch)) this.selectCardColor(swatch);
    }
    openDialog(dialog, trigger) {
      if (!dialog) return;
      if (this.openModal?.open) this.openModal.close();
      this.returnFocus = trigger;
      this.previousOverflow = document.documentElement.style.overflow;
      this.openModal = dialog;
      dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      dialog.querySelector('[data-close-dialog]')?.focus({preventScroll:true});
    }
    applyFilters(event) {
      event.preventDefault();
      const form = event.target;
      const min = form.querySelector('[data-price-min]');
      const max = form.querySelector('[data-price-max]');
      if (min && max && min.value !== '' && max.value !== '' && Number(min.value) > Number(max.value)) {
        max.setCustomValidity('Maximum price must be greater than or equal to minimum price.');
        max.reportValidity(); return;
      }
      if (!form.reportValidity()) return;
      const url = new URL(form.action, location.origin);
      url.search = '';
      new FormData(form).forEach((value, key) => {
        if (String(value).trim() !== '') url.searchParams.append(key, value);
      });
      location.assign(url.href);
    }
    routeRoot() {
      let root = window.Shopify?.routes?.root || this.dataset.root || '/';
      return root.endsWith('/') ? root : root + '/';
    }
    async product(url) {
      const u = new URL(url, location.origin);
      const handle = u.pathname.split('/').filter(Boolean).pop();
      const endpoint = this.routeRoot() + 'products/' + encodeURIComponent(decodeURIComponent(handle)) + '.js';
      if (!this.cache.has(endpoint)) {
        const promise = fetch(endpoint, {credentials:'same-origin', headers:{Accept:'application/json'}})
          .then(response => { if (!response.ok) throw new Error('Product could not be loaded.'); return response.json(); })
          .then(data => { if (!Array.isArray(data.variants)) throw new Error('Product could not be loaded.'); return data; })
          .catch(error => { this.cache.delete(endpoint); throw error; });
        this.cache.set(endpoint, promise);
      }
      return this.cache.get(endpoint);
    }
    money(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:this.dataset.currency || 'USD'}).format(Number(cents || 0) / 100);
    }
    node(tag, className, text) {
      const element = document.createElement(tag);
      if (className) element.className = className;
      if (text !== undefined) element.textContent = text;
      return element;
    }
    imageUrl(value, width = 960) {
      const raw = typeof value === 'object' ? value?.src || value?.url : value;
      if (!raw) return '';
      const url = new URL(raw, location.origin);
      if (!['https:','http:'].includes(url.protocol)) return '';
      url.searchParams.set('width', String(width));
      return url.href;
    }
    setImage(image, value) {
      const url = this.imageUrl(value);
      if (!url || !image) return;
      image.srcset = [240,360,480,640,960].map(width => this.imageUrl(value,width) + ' ' + width + 'w').join(', ');
      image.src = url;
    }
    variantUrl(base, id) {
      const url = new URL(base, location.origin);
      if (id) url.searchParams.set('variant',String(id));
      return url.pathname + url.search;
    }
    async selectCardColor(button) {
      const card = button.closest('[data-product-card]');
      const status = card.querySelector('[data-card-status]');
      const index = Number(card.dataset.colorIndex);
      if (index < 0) return;
      const token = String(Number(card.dataset.requestToken || 0) + 1);
      card.dataset.requestToken = token;
      status.textContent = '';
      card.setAttribute('aria-busy','true');
      try {
        const p = await this.product(card.dataset.url);
        if (card.dataset.requestToken !== token || !this.isConnected) return;
        if (p.variants.length >= 250) { this.showQuickView(card,button); return; }
        const color = button.dataset.colorValue;
        const matches = p.variants.filter(v => v.options[index] === color);
        const variant = matches.find(v => v.available) || matches[0];
        if (!variant) { status.textContent = 'View the product page to choose this color.'; return; }
        card.dataset.color = color;
        card.dataset.variantId = String(variant.id);
        card.querySelectorAll('button[data-color-value]').forEach(b => b.setAttribute('aria-pressed',String(b === button)));
        card.querySelectorAll('[data-product-link]').forEach(a => a.href = this.variantUrl(card.dataset.url, variant.id));
        const mainSource = variant.featured_image?.src || variant.featured_image?.url || p.featured_image;
        this.setImage(card.querySelector('.mec__image--first'), mainSource);
        const currentPath = mainSource ? new URL(mainSource,location.origin).pathname : '';
        const imageIndex = p.images.findIndex(image => new URL(typeof image === 'string' ? image : image.src,location.origin).pathname === currentPath);
        if (p.images.length > 1) {
          const next = p.images[(Math.max(0,imageIndex) + 1) % p.images.length];
          this.setImage(card.querySelector('.mec__image--next'), next);
        }
        const amounts = matches.map(v => Number(v.price));
        const low = Math.min(...amounts), high = Math.max(...amounts);
        const price = card.querySelector('[data-card-price]');
        price.replaceChildren(this.node('span','', (low !== high ? 'From ' : '') + this.money(low)));
        if (low === high && variant.compare_at_price > low) price.append(this.node('s','',this.money(variant.compare_at_price)));
        const sizeIndex = Number(card.dataset.sizeIndex);
        card.querySelectorAll('[data-size-value]').forEach(size => {
          const available = matches.some(v => v.available && v.options[sizeIndex] === size.dataset.sizeValue);
          size.classList.toggle('mec__size-unavailable', !available);
        });
      } catch (error) {
        if (card.dataset.requestToken === token) status.textContent = 'Unable to update the preview. Open the product page for all options.';
      } finally {
        if (card.dataset.requestToken === token) card.removeAttribute('aria-busy');
      }
    }
    async showQuickView(card, trigger) {
      if (!card) return;
      this.quickBody.replaceChildren(this.node('p','mec__quick-status','Loading product…'));
      this.openDialog(this.quickDialog, trigger);
      const token = ++this.requestToken;
      try {
        const p = await this.product(card.dataset.url);
        if (token !== this.requestToken || !this.quickDialog.open || !this.isConnected) return;
        this.renderQuickView(p,card);
      } catch (error) {
        if (token !== this.requestToken || !this.quickDialog.open) return;
        const link = this.node('a','mec__details-link','View product details');
        link.href = card.dataset.url;
        this.quickBody.replaceChildren(this.node('p','','Unable to load Quick View. Please open the product page.'),link);
      }
    }
    renderQuickView(p,card) {
      const layout = this.node('div','mec__quick-layout');
      const image = this.node('img','mec__quick-image');
      image.alt = p.title; image.width = 800; image.height = 1000;
      if (p.featured_image) image.src = this.imageUrl(p.featured_image);
      else image.hidden = true;
      const info = this.node('div','mec__quick-info');
      const heading = this.node('h3','mec__quick-name',p.title);
      const price = this.node('p','mec__quick-price');
      const link = this.node('a','mec__details-link','View full details');
      link.href = card.dataset.url;
      info.append(heading,price);
      layout.append(image,info);
      this.quickBody.replaceChildren(layout);
      if (p.variants.length >= 250 || p.requires_selling_plan || p.variants.some(v=>v.requires_selling_plan)) {
        price.textContent = (p.price_varies ? 'From ' : '') + this.money(p.price);
        info.append(this.node('p','mec__quick-status','Choose your options on the product page.'),link);
        return;
      }
      const form = this.node('form','mec__quick-form');
      const options = (p.options || []).map((option,index) => ({
        name: typeof option === 'string' ? option : option.name,
        values: [...new Set(p.variants.map(v=>v.options[index]))].filter(v=>v != null)
      }));
      let selected = p.variants.find(v=>String(v.id) === card.dataset.variantId) || p.variants.find(v=>v.available) || p.variants[0];
      const singleDefault = options.length === 1 && options[0].name === 'Title' && options[0].values.length === 1 && options[0].values[0] === 'Default Title';
      const selects = [];
      if (!singleDefault) options.forEach((option,index) => {
        const label = this.node('label','mec__option',option.name);
        const select = this.node('select','mec__option-select');
        select.setAttribute('aria-label',option.name);
        option.values.forEach(value => {const item = this.node('option','',value); item.value = value; select.append(item);});
        select.value = selected?.options[index] || option.values[0] || '';
        label.append(select); form.append(label); selects.push(select);
      });
      const status = this.node('p','mec__quick-status'); status.setAttribute('role','status');
      const add = this.node('button','mec__primary','Add to cart'); add.type = 'submit';
      form.append(status,add); info.append(form,link);
      const update = (changedIndex = -1) => {
        selects.forEach((select,index) => {
          const prefix = selects.slice(0,index).map(s=>s.value);
          const purchasable = p.variants.filter(v => v.available && prefix.every((value,i)=>v.options[i]===value));
          [...select.options].forEach(option => {
            const available = purchasable.some(v=>v.options[index]===option.value);
            option.disabled = !available;
            option.textContent = option.value + (available ? '' : ' — Sold out');
          });
          if (index > changedIndex && changedIndex >= 0 && select.selectedOptions[0]?.disabled) {
            const first = [...select.options].find(option=>!option.disabled);
            if (first) select.value = first.value;
          }
        });
        const values = selects.map(s=>s.value);
        selected = singleDefault ? p.variants[0] : p.variants.find(v=>values.every((value,index)=>v.options[index]===value));
        price.replaceChildren(this.node('span','',this.money(selected?.price ?? p.price)));
        if (selected?.compare_at_price > selected?.price) price.append(this.node('s','',this.money(selected.compare_at_price)));
        add.disabled = !selected?.available;
        add.textContent = selected?.available ? 'Add to cart' : selected ? 'Sold out' : 'Unavailable';
        status.textContent = selected && !selected.available ? 'This option is currently sold out.' : '';
        link.href = this.variantUrl(card.dataset.url,selected?.id);
        const source = selected?.featured_image?.src || selected?.featured_image?.url || p.featured_image;
        if (source) {image.hidden = false; image.src = this.imageUrl(source);}
      };
      selects.forEach((select,index)=>select.addEventListener('change',()=>update(index)));
      update();
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (!selected?.available || add.disabled) return;
        add.disabled = true; add.textContent = 'Adding…'; status.textContent = '';
        try {
          const response = await fetch(this.routeRoot() + 'cart/add.js', {
            method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json',Accept:'application/json'},
            body:JSON.stringify({items:[{id:selected.id,quantity:1}]})
          });
          const data = await response.json();
          if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : 'Unable to add this item. Please try again.');
          location.assign(this.dataset.cartUrl || this.routeRoot() + 'cart');
        } catch (error) {
          status.textContent = error.message || 'Unable to add this item. Please try again.';
          add.disabled = !selected?.available; add.textContent = 'Add to cart';
        }
      });
    }
  }
  customElements.define('mag-editorial-collection',MagEditorialCollection);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mag-recently-viewed"] && !Shopify.designMode) return;
  try {
    
(() => {
  const KEY = 'mag-recently-viewed-v1';
  const el = (tag, cls, text) => { const node = document.createElement(tag); if (cls) node.className = cls; if (text != null) node.textContent = text; return node; };
  const imgUrl = x => { const raw = typeof x === 'string' ? x : (x && (x.src || x.url)); if (!raw) return ''; try { const u = new URL(raw, location.origin); return /^https?:$/.test(u.protocol) ? u.href : ''; } catch (_) { return ''; } };
  const val = (v,i) => (v.options && v.options[i]) || v['option'+(i+1)] || '';
  const optionName = o => typeof o === 'string' ? o : (o && o.name) || '';
  const findIndex = (p, pattern) => (p.options || []).findIndex(o => pattern.test(optionName(o).trim()));
  const choices = (p,i) => [...new Set((p.variants || []).map(v => val(v,i)).filter(Boolean))];
  // 店铺货币格式可能含有插件包装的 HTML；先取出纯文本，再交由 textContent 安全显示。
  const plainMoneyFormat = format => {
    const template = document.createElement('template');
    template.innerHTML = String(format || '${{amount}}');
    return template.content.textContent || '${{amount}}';
  };
  const money = (cents, format) => {
    const n = (Number(cents) || 0) / 100;
    return (format || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/g, (_, key) => {
      const zero = /no_decimals/.test(key), dec = zero ? 0 : 2;
      let [a,b] = n.toFixed(dec).split('.');
      const comma = /comma_separator/.test(key), space = /space_separator/.test(key), apostrophe = /apostrophe_separator/.test(key);
      a = a.replace(/\B(?=(\d{3})+(?!\d))/g, space ? ' ' : apostrophe ? "'" : comma ? '.' : ',');
      return a + (b ? (comma || space ? ',' : '.') + b : '');
    });
  };
  const colorValue = name => {
    const n = String(name).toLowerCase().trim();
    const map = {black:'#18191b',white:'#f7f7f5',grey:'#888',gray:'#888',navy:'#283547',blue:'#4264af',green:'#526451',olive:'#687052',brown:'#795643',beige:'#d6c7b3',khaki:'#c1b396',pink:'#d6a5ac',red:'#a93335',purple:'#6c5877',orange:'#cc7845',yellow:'#dbbc59',cream:'#ede8d9'};
    const key = Object.keys(map).find(k => n === k || new RegExp('(^|[^a-z])'+k+'([^a-z]|$)').test(n));
    return map[key] || '#d1d1d1';
  };
  function setup(root) {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const design = root.dataset.designMode === 'true';
    const rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || root.dataset.root || '/';
    const base = rootPath.endsWith('/') ? rootPath : rootPath + '/';
    const track = root.querySelector('.mrv__track'), carousel = root.querySelector('.mrv__carousel'), empty = root.querySelector('.mrv__empty');
    const dialog = root.querySelector('dialog'), modal = root.querySelector('.mrv__modal-content');
    const prev = root.querySelector('.mrv__prev'), next = root.querySelector('.mrv__next');
    const format = plainMoneyFormat(root.dataset.moneyFormat);
    let handles = [];
    try {
      const parsed = JSON.parse(localStorage.getItem(KEY) || '[]');
      handles = Array.isArray(parsed) ? parsed.filter(x => typeof x === 'string' && x.length < 256) : [];
      handles = [...new Set(handles)].slice(0,30);
      const current = root.dataset.currentHandle;
      if (current && !design) {
        handles = [current, ...handles.filter(h => h !== current)].slice(0,30);
        localStorage.setItem(KEY, JSON.stringify(handles));
      }
    } catch (_) { handles = []; }
    const wanted = handles.filter(h => h !== root.dataset.currentHandle);
    const updateArrows = () => { prev.disabled = track.scrollLeft <= 2; next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2; };
    track.addEventListener('scroll', updateArrows, {passive:true});
    prev.addEventListener('click', () => track.scrollBy({left:-track.clientWidth*.85,behavior:'smooth'}));
    next.addEventListener('click', () => track.scrollBy({left:track.clientWidth*.85,behavior:'smooth'}));
    window.addEventListener('resize', updateArrows, {signal: (root._mrvController = new AbortController()).signal});
    root.querySelector('.mrv__close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', e => { if (e.target === dialog) dialog.close(); });
    function productUrl(p) { return base + 'products/' + encodeURIComponent(p.handle); }
    function openQuick(p) {
      modal.replaceChildren();
      const picture = el('img','mrv__modal-image'); picture.alt = p.title || ''; picture.src = imgUrl(p.featured_image || (p.images || [])[0]);
      const info = el('div','mrv__modal-info');
      info.append(el('h3','mrv__modal-title',p.title), el('p','mrv__modal-price',money(p.price,format)));
      const variants = p.variants || [], options = p.options || [];
      const initial = variants.find(v => v.available) || variants[0];
      const selects = [];
      if (!(options.length === 1 && /^title$/i.test(optionName(options[0])) && choices(p,0).length === 1 && choices(p,0)[0] === 'Default Title')) {
        options.forEach((option,i) => {
          const label = el('label','mrv__option-label',optionName(option));
          const select = el('select','mrv__select'); select.setAttribute('aria-label',optionName(option));
          choices(p,i).forEach(name => { const item = el('option','',name); item.value = name; select.append(item); });
          if (initial) select.value = val(initial,i);
          label.append(select); info.append(label); selects.push({select,i});
        });
      }
      const notice = el('div','mrv__notice'); notice.setAttribute('role','status');
      const add = el('button','mrv__add','Add to cart'); add.type='button';
      const productLink = el('a','mrv__product-link','View full details'); productLink.href = productUrl(p);
      const needsPage = variants.length >= 250 || p.requires_selling_plan === true;
      const currentVariant = () => variants.find(v => selects.every(o => val(v,o.i) === o.select.value));
      function refresh() {
        const variant = currentVariant();
        const restricted = needsPage || (variant && variant.requires_selling_plan);
        add.disabled = restricted || !variant || !variant.available;
        add.textContent = restricted ? 'Choose options on product page' : !variant ? 'Unavailable combination' : !variant.available ? 'Sold out' : 'Add to cart';
        const price = info.querySelector('.mrv__modal-price');
        if (variant) price.textContent = money(variant.price,format);
        const source = variant && imgUrl(variant.featured_image); if (source) picture.src = source;
        notice.textContent = restricted ? 'Please select this product on its product page.' : '';
      }
      selects.forEach(o => o.select.addEventListener('change',refresh));
      add.addEventListener('click', async () => {
        const variant = currentVariant(); if (!variant || !variant.available) return;
        add.disabled=true; add.textContent='Adding…'; notice.textContent='';
        try {
          const response=await fetch(base+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:variant.id,quantity:1}]})});
          if (!response.ok) { const error=await response.json().catch(()=>({})); throw new Error(error.description || 'Could not add to cart.'); }
          location.href=base+'cart';
        } catch (error) { notice.textContent=error.message || 'Could not add to cart.'; refresh(); notice.textContent=error.message || 'Could not add to cart.'; }
      });
      info.append(add,notice,productLink); modal.append(picture,info); refresh();
      if (typeof dialog.showModal === 'function') dialog.showModal(); else location.href=productUrl(p);
    }
    function card(p) {
      const box=el('article','mrv__card'), media=el('div','mrv__media');
      const imageLink=el('a','mrv__image-link'); imageLink.href=productUrl(p); imageLink.setAttribute('aria-label',p.title || 'Product');
      const images = (p.images || []).map(imgUrl).filter(Boolean);
      const first = imgUrl(p.featured_image) || images[0];
      if (first) { const image=el('img','mrv__primary'); image.src=first; image.alt=p.title || ''; image.loading='lazy'; imageLink.append(image); }
      const second = images.find(url => url !== first);
      if (second) { const image=el('img','mrv__secondary'); image.src=second; image.alt=''; image.loading='lazy'; imageLink.append(image); }
      media.append(imageLink);
      if (root.dataset.imageDescription) media.append(el('span','mrv__image-description',root.dataset.imageDescription));
      const quickLabel = root.dataset.quickLabel || 'Quick View';
      const quick=el('button','mrv__quick',quickLabel); quick.type='button'; quick.setAttribute('aria-label',quickLabel+': '+p.title); quick.addEventListener('click',()=>openQuick(p)); media.append(quick); box.append(media);
      const details=el('div','mrv__details');
      const colorIndex=findIndex(p,/^(color|colour|颜色|顏色)$/i);
      if (colorIndex >= 0) {
        const row=el('div','mrv__swatches'); row.setAttribute('aria-label','Colors');
        choices(p,colorIndex).slice(0,12).forEach(name=>{
          const dot=el('span','mrv__swatch'); dot.title=name; dot.setAttribute('role','img'); dot.setAttribute('aria-label',name); dot.style.backgroundColor=colorValue(name);
          const variant=(p.variants || []).find(v => val(v,colorIndex) === name && v.featured_image); const src=variant && imgUrl(variant.featured_image);
          if (src) dot.style.backgroundImage='url('+JSON.stringify(src)+')'; row.append(dot);
        }); details.append(row);
      }
      const title=el('a','mrv__product-title',p.title); title.href=productUrl(p); details.append(title);
      details.append(el('p','mrv__price',money(p.price,format)));
      const sizeIndex=findIndex(p,/^(size|sizes|尺码|尺碼|尺寸)$/i);
      if (root.dataset.showSizes === 'true' && sizeIndex >= 0) { const sizes=choices(p,sizeIndex); if (sizes.length) details.append(el('p','mrv__sizes',sizes.join(' / '))); }
      box.append(details); return box;
    }
    async function load() {
      if (!wanted.length) { if (design) empty.hidden=false; else root.hidden=true; return; }
      const results=await Promise.all(wanted.map(async handle => {
        try { const res=await fetch(base+'products/'+encodeURIComponent(handle)+'.js',{headers:{Accept:'application/json'}}); return res.ok ? await res.json() : null; } catch (_) { return null; }
      }));
      const products=results.filter(p => p && p.handle && p.title).slice(0,10);
      if (!products.length) { if (design) empty.hidden=false; else root.hidden=true; return; }
      products.forEach(p => track.append(card(p))); carousel.hidden=false; requestAnimationFrame(updateArrows);
    }
    load();
  }
  const init = scope => { if (scope.matches && scope.matches('[data-mrv]')) setup(scope); if (scope.querySelectorAll) scope.querySelectorAll('[data-mrv]').forEach(setup); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>init(document)); else init(document);
  document.addEventListener('shopify:section:load',e=>init(e.target));
  document.addEventListener('shopify:section:unload',e=>{ const root=e.target.querySelector('[data-mrv]'); if(root && root._mrvController) root._mrvController.abort(); });
})();

  } catch(e) { console.error(e); }
})();
})();
